import { isProd } from '../../config/config';

export const URL_SHORTENER_LINK_DOMAIN = isProd ? 'share.teamengine.io' : 'localhost:3000';
